import React from "react";
import DashLayout from "../../layouts/DashLayout";
import { notifs } from "../../utils/DataSource";
import { AiOutlineDelete } from "react-icons/ai";
function Notifications() {
  return (
    <DashLayout>
      <div className="bg-white rounded mx-10">
        <div className="flex p-10 pl-10 pb-4">
          <h2 className="font-semibold">All notifications</h2>
          <span className="bg-red-100 text-red-500 rounded-full px-1 ml-1">
            {notifs.length}
          </span>
        </div>
        <div className="border-b border-gray-100 ml-10 mr-10" />
        <div className="p-5 pl-10 flex flex-wrap  w-full">
          <div className="p-0 pb-3 w-full">
            {notifs.map((notif, i) => {
              return (
                <div
                  className="flex flex-col w-full  bg-gray-50  text-gray-500 text-xs py-3 p-3 pl-7 cursor-pointer border hover:bg-gray-100 border-gray-100"
                  key={i}
                >
                  <div className="flex">
                    <div
                      className={
                        notif.actionCode === "DELETE"
                          ? "m-auto ml-0 mr-3 w-2 h-2 bg-red-300 rounded-full "
                          : "m-auto ml-0 mr-3 w-2 h-2 bg-indigo-300 rounded-full bg-"
                      }
                    />
                    <h2 className="font-semibold w-32  my-auto mr-3">
                      {notif.source}
                    </h2>
                  </div>
                  <div className="flex ml-5 pt-2 w-full pr-6">
                    <div className="flex flex-col md:flex-row w-full">
                      <div className="md:w-2/3 md:mr-4">
                        <p className="text-gray-600">{notif.message}</p>
                        <p>done by {notif.doneBy}</p>
                      </div>
                      <span className="md:m-auto text-indigo-500 rounded">{notif.time}</span>
                    </div>
                    <div className="m-auto mr-0">
                      <button className="flex p-1 m-auto rounded  bg-red-100 hover:bg-red-300 text-red-500 mr-2">
                        <AiOutlineDelete />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </DashLayout>
  );
}

export default Notifications;
